import classNames from "classnames";


// Mobile
// Tablet
// All

export const container = classNames(
    // Mobile
    "mobile:p-0",
    "mobile:bg-[url(/assets/images/backgrounds/free-resources/mobile.svg)]",
    "mobile:bg-left",
    "mobile:bg-[position:3px_-62px]",
    "mobile:pl-2",
    // Tablet
    "tablet:bg-[url(/assets/images/backgrounds/free-resources/desktop.svg)]",
    "tablet:bg-right-top",
    "tablet:bg-auto",
    "tablet:p-8",
    "tablet:m-2",
    // All
    "bg-no-repeat",
)

export const headingContainer = classNames(
    // Mobile
    "mobile:p-8",
    // Tablet
    "tablet:p-6",
    // All
    "flex",
    "flex-col",
    "justify-center",
    "items-center",
)

export const subheading = classNames(
    // Mobile
    "mobile:text-md",
    "mobile:pt-2",
    // Tablet
    "tablet:text-2xl",
    "tablet:pt-4",
    // All
)
